import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#060709]">
      <div className="px-5 md:px-10 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-display font-extrabold text-3xl tracking-tight">RVIOR<span className="text-volt align-super text-xs font-mono">®</span></p>
          <p className="font-edit italic text-dim mt-3">Subversive luxury streetwear,<br />engineered in New Delhi.</p>
        </div>
        <div className="flex flex-col gap-3 font-mono text-[11px] tracking-[0.2em] text-dim">
          <Link to="/shop" className="hover:text-acid transition-colors">SHOP DROP 001</Link>
          <Link to="/track" className="hover:text-acid transition-colors">TRACK ORDER</Link>
          <Link to="/refund" data-testid="footer-refund-link" className="hover:text-acid transition-colors">CANCELLATION & REFUNDS</Link>
          <Link to="/shipping" data-testid="footer-shipping-link" className="hover:text-acid transition-colors">SHIPPING POLICY</Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-acid transition-colors">PRIVACY POLICY</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-acid transition-colors">TERMS & CONDITIONS</Link>
          <a href="mailto:rviorclothing@gmail.com" data-testid="footer-contact-link" className="hover:text-acid transition-colors">CONTACT: RVIORCLOTHING@GMAIL.COM</a>
          <Link to="/contact" data-testid="footer-contact-page-link" className="hover:text-acid transition-colors">SEND US A MESSAGE →</Link>
          <Link to="/admin" className="hover:text-acid transition-colors">ADMIN PORTAL</Link>
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-mute leading-loose">
          <p>FULFILMENT: MADE TO ORDER · 24-48H DISPATCH</p>
          <p>DISPATCH: PAN-INDIA · 3-7 BUSINESS DAYS</p>
          <p>PAYMENTS: RAZORPAY SECURE PREPAID · COD ON DELIVERY</p>
          <p className="mt-4 text-dim">© {new Date().getFullYear()} RVIOR. ALL RIGHTS RESERVED.</p>
        </div>
      </div>
      <div className="overflow-hidden border-t border-white/10">
        <p className="font-display font-extrabold text-[18vw] leading-[0.8] text-[#101318] text-center select-none tracking-tighter -mb-[4vw]">
          RVIOR
        </p>
      </div>
    </footer>
  );
}
